<template>
    <b-container class="pr-0">
        <b-row no-gutters>
            <b-col v-if="!!title" cols="3" class="d-flex justify-content-center align-items-center">
                <b> {{ title }}</b>
            </b-col>
            <b-col v-if="!!filters.find(x => x === 'assetSearch')">
                <b-form-input
                    id="input-to"
                    type="search"
                    v-model="assetSearch"
                    placeholder="Asset Search...."
                    size="sm"
                    class="mr-sm-2 mb-sm-0"
                ></b-form-input>
            </b-col>
            <b-col v-if="!!filters.find(x => x === 'role')">
                <b-form-select
                    id="input-role"
                    v-model="role"
                    :options="roles"
                    size="sm"
                    class="mr-sm-2 mb-sm-0"
                >
                    <template #first>
                        <b-form-select-option :value="null"
                            >--Any Role--</b-form-select-option
                        >
                    </template>
                </b-form-select>
            </b-col>
            <b-col v-if="!!filters.find(x => x === 'officer')">
                <b-form-select
                    id="input-officer"
                    v-model="officer"
                    :options="officers"
                    size="sm"
                    class="mr-sm-2 mb-sm-0"
                >
                    <template #first>
                        <b-form-select-option :value="null"
                            >--Any Officer--</b-form-select-option
                        >
                    </template>
                </b-form-select>
            </b-col>

            <b-col sm="4" lg="3" v-if="!!filters.find(x => x === 'orderType')">
                <b-form-select
                    id="input-order-type"
                    v-model="orderType"
                    :options="orderTypes"
                    size="sm"
                    class="mr-sm-2 mb-sm-0"
                >
                    <template #first>
                        <b-form-select-option :value="null"
                            >--Any Activity Type--</b-form-select-option
                        >
                    </template>
                </b-form-select>
            </b-col>

            <b-col v-if="!!filters.find(x => x === 'assetType')">
                <b-form-select
                    id="input-asset-type"
                    v-model="assetType"
                    :options="assetTypes"
                    size="sm"
                    class="mr-sm-2 mb-sm-0"
                >
                    <template #first>
                        <b-form-select-option :value="null"
                            >--Any Asset Type--</b-form-select-option
                        >
                    </template>
                </b-form-select>
            </b-col>
            <b-col v-if="!!filters.find(x => x === 'dataRange')">
                <b-form-input
                    id="input-from"
                    type="date"
                    v-model="range.from"
                    size="sm"
                    class="mr-sm-2 mb-sm-0"
                ></b-form-input>
            </b-col>
            <b-col v-if="!!filters.find(x => x === 'dataRange')">
                <b-form-input
                    id="input-to"
                    type="date"
                    v-model="range.to"
                    size="sm"
                    class="mr-sm-2 mb-sm-0"
                ></b-form-input>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
const todayDate = new Date().toISOString().split('T')[0]
const sevenMonthEralier = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000)
    .toISOString()
    .split('T')[0]
export default {
    data() {
        return {
            assetSearch: null,
            officer: null,
            role: null,
            orderType: null,
            assetType: null,
            range: {
                from: sevenMonthEralier,
                to: todayDate,
            },
        }
    },
    props: {
        title: { type: String, default: () => null },
        officers: { type: Array, default: () => [] },
        roles: { type: Array, default: () => [] },
        orderTypes: { type: Array, default: () => [] },
        assetTypes: { type: Array, default: () => [] },
        filters: { type: Array, default: () => [] },
    },
    watch: {
        assetSearch: function (val) {
            this.$emit('asset-search', val)
        },

        officer: function (val) {
            this.$emit('select-officer', val)
        },

        role: function (val) {
            this.officer = null
            this.$emit('select-role', val)
        },

        assetType: function (val) {
            this.$emit('select-asset-type', val)
        },

        orderType: function (val) {
            this.$emit('select-order-type', val)
        },

        range: {
            handler: function (val) {
                this.$emit('select-range', val)
            },
            deep: true,
        },
    },
}
</script>
<style> 
.row.no-gutters {
    margin-right: -6px !important;
    margin-left: -6px !important;
}
@media (max-width: 767.98px) {
 
 .leaflet-left{
     margin-top: 40px !important;
 }
 .leaflet-right{
     margin-left: 10px !important;
 }
}
</style>